// src/components/Bookings/BookingSuccess.jsx
import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePaymentConfirmation } from '../../utils/payment';

// Al llegar aquí confirmamos el pago con el backend (que lo consulta a
// Stripe) para que la reservación pase a "confirmed" de inmediato, aunque
// el webhook todavía no haya llegado.
const BookingSuccess = () => {
  const { t } = useTranslation('common');
  const [searchParams] = useSearchParams();
  const payment = usePaymentConfirmation(searchParams.get('session_id'));
  const confirmed = payment === 'paid' || payment === 'unknown';

  return (
    <div className="bg-[#EFE6DD] min-h-screen flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full bg-white rounded-2xl border border-[#3A2A20]/10 overflow-hidden text-center">
        {/* Imagen clickeable */}
        <Link to="/my-bookings" className="block group">
          <div className="h-48 overflow-hidden">
            <img
              src="https://res.cloudinary.com/dc6xthiol/image/upload/v1743411835/categories_accesorios_xwqarp.jpg"
              alt={t('bookingSuccess.imageAlt')}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </Link>

        <div className="p-8">
          {/* Badge verde de "todo listo" */}
          <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#3A6B4C]/10">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.5}
              className="h-7 w-7 text-[#3A6B4C]"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          </div>

          {payment === 'checking' ? (
            <p className="text-sm text-[#3A2A20]/60">{t('paymentStatus.confirming')}</p>
          ) : confirmed ? (
            <>
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#3A6B4C]">
                {t('bookingSuccess.eyebrow')}
              </span>
              <h1 className="mt-2 font-['Fraunces'] text-2xl sm:text-3xl font-semibold text-[#3A2A20]">
                {t('bookingSuccess.title')}
              </h1>
              <p className="text-[#3A2A20]/70 text-sm mt-3 leading-relaxed">
                {t('bookingSuccess.message')}
              </p>
            </>
          ) : (
            <>
              <h1 className="font-['Fraunces'] text-2xl sm:text-3xl font-semibold text-[#3A2A20]">
                {t('paymentStatus.processingTitle')}
              </h1>
              <p className="text-[#3A2A20]/70 text-sm mt-3 leading-relaxed">
                {t('paymentStatus.processingMessage')}
              </p>
            </>
          )}

          <Link
            to="/my-bookings"
            className="mt-6 inline-block w-full px-6 py-3.5 bg-[#9A0002] hover:bg-[#7A0001] text-[#EFE6DD] rounded-xl text-sm font-medium transition"
          >
            {t('bookingSuccess.viewBookings')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccess;
